import React, { useEffect, useState } from "react";
import { isMobile } from 'lib/checkuseros';

import Button from "../../../button";

import {listOfPosters} from './config'

import "./styles.less";

export const AutoSlider = ({ onCardButtonClick, actionButtonText = "", paused = false }) => {
  const [scrollerContent, setScrollerContent] = useState([]);
  const isMobileOS = isMobile()

  useEffect(() => {
      const duplicatedContentEnd = listOfPosters.map((item, index) => ({
        ...item,
        key: `${item.title}-end-${index}`,
        isDuplicate: true,
      }));

      setScrollerContent([...listOfPosters, ...duplicatedContentEnd]);
  }, []);


  const handleCardClick = () => {
    if (isMobileOS) {
      onCardButtonClick();
    }
    return;
  };

  return (
    <div className={`auto-slider ${isMobileOS ? 'auto-slider--mobile': 'auto-slider--desktop'}`} data-paused={paused} data-animated="true" data-direction="left">
      <div className="auto-slider__inner">
        {scrollerContent.map(({ img, title, description, isDuplicate, key }) => (
          <div onClick={handleCardClick} key={key} className="auto-slider__element" aria-hidden={isDuplicate}>
            <img className="auto-slider__element-img" src={img} alt={title} />
            <div className="auto-slider__element-content">
              <p className="auto-slider__element-content-title">{title}</p>
              <p className="auto-slider__element-content-text">{description}</p>
              <Button
                handleClick={onCardButtonClick}
                width="100%"
                text={actionButtonText}
                variant="default"
                size="sm"
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/js/components/pages/newLandingPage/block-slider/сomponents/auto-slider/index.js